module.exports = __webpack_public_path__ + "h5/img/bb4.f80fb1d5.png";